import React from "react";
import { createRoot } from "react-dom/client";
import { ThemeProvider } from "@mui/material";
import { GoogleOAuthProvider } from "@react-oauth/google"

import App from "./App.jsx";
import theme from "./theme/Theme";
import * as serviceWorker from "./serviceWorker";
import { appConfig } from "./config";
import { initGoogleAnalytics } from "./utils/googleAnalytics";

import "./index.css";
import "./scss/index.scss";

// Extract environment variables
const googleClientId = appConfig.googleClientId || '';

initGoogleAnalytics();

const container = document.getElementById("root");
const root = createRoot(container);
root.render(
  // Temporarily disabled React.StrictMode due to React 18 + React Router v5 compatibility issues
  // TODO: Re-enable after upgrading to React Router v6
  // <React.StrictMode>
    <ThemeProvider theme={theme}>
      <GoogleOAuthProvider clientId={googleClientId}>
        <App />
      </GoogleOAuthProvider>
    </ThemeProvider>
  // </React.StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
